export class Profile {
  username: string;
  bio: string;
  image: string;
  followingCount: number;
  followerCount: number;
  discussionCount: number;
  communityCount: number;
  isFollowing: {
    followedBy: boolean;
    following: boolean;
  };
  createdAt: string;
  updatedAt: string;
}
